/* This file is generated by scripts/process-messages/index.js. Do not edit! */

import { DEV } from 'esm-env';

var bold = 'font-weight: bold';
var normal = 'font-weight: normal';

/**
 * A `hydratable` value with key `%key%` was created, but at least part of it was not used during the render.
 * 
 * The `hydratable` was initialized in:
 * %stack%
 * @param {string} key
 * @param {string} stack
 */
export function unresolved_hydratable(key, stack) {
	if (DEV) {
		console.warn(
			`%c[svelte] unresolved_hydratable\n%cA \`hydratable\` value with key \`${key}\` was created, but at least part of it was not used during the render.

The \`hydratable\` was initialized in:
${stack}\nhttps://svelte.dev/e/unresolved_hydratable`,
			bold,
			normal
		);
	} else {
		console.warn(`https://svelte.dev/e/unresolved_hydratable`);
	}
}